export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="w-full max-w-6xl mx-auto px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-microscope-line text-lg"></i>
              </div>
              <div>
                <div className="font-heading text-base tracking-[0.1em]">原因究明研究所</div>
                <div className="text-[10px] tracking-[0.2em] text-background-300">
                  ROOT CAUSE LABORATORY
                </div>
              </div>
            </div>
            <p className="text-sm text-background-300 leading-relaxed max-w-md">
              中小製造業の不良現象について、
              原因究明から改善策・評価方法の設計まで支援します。
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.25em] text-background-400 mb-4">CONTENT</div>
            <ul className="space-y-2 text-sm">
              {[
                { id: "service", label: "サービス内容" },
                { id: "approach", label: "アプローチ" },
                { id: "fields", label: "対応分野" },
                { id: "cases", label: "実績・事例" },
              ].map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => scrollTo(l.id)}
                    className="text-background-200 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.25em] text-background-400 mb-4">SUPPORT</div>
            <ul className="space-y-2 text-sm mb-6">
              {[
                { id: "pricing", label: "料金" },
                { id: "flow", label: "ご相談の流れ" },
                { id: "faq", label: "FAQ" },
                { id: "contact", label: "お問い合わせ" },
              ].map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => scrollTo(l.id)}
                    className="text-background-200 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
            <button
              onClick={() => scrollTo("contact")}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-400 text-background-50 text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-send-line"></i>
              お問い合わせはこちら
            </button>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © 2026 原因究明研究所. All rights reserved.
          </p>
          <p className="text-xs text-background-400 tracking-wider">
            問題は、解き明かされることを待っています。
          </p>
        </div>
      </div>
    </footer>
  );
}